import { render } from "./PhonePart3.vue?vue&type=template&id=46879331"
import script from "./PhonePart3.vue?vue&type=script&lang=js"
export * from "./PhonePart3.vue?vue&type=script&lang=js"

import "./PhonePart3.vue?vue&type=style&index=0&id=46879331&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__